/** Deep Dive API service. */

import { apiClient } from '../client';
import { API_ENDPOINTS } from '../endpoints';
import type { DeepDiveResponse, StockPricesResponse } from '@/types/responses';
import type { HypeScoreWindow } from '@/stores/dashboard';

export async function fetchDeepDiveData(
  ticker: string,
  window: HypeScoreWindow = '30d'
): Promise<DeepDiveResponse | null> {
  try {
    const url = `${API_ENDPOINTS.deepDive(ticker)}?window=${encodeURIComponent(window)}`;
    const response = await apiClient.get<DeepDiveResponse>(url);
    return response.data;
  } catch (error) {
    console.error(`Error fetching deep dive data for ${ticker}:`, error);
    throw error;
  }
}

export async function fetchHistoricalPrice(ticker: string): Promise<Array<{ Date: string; Close: number; Volume?: number | null }> | null> {
  try {
    const response = await apiClient.get<{ historical_price: Array<{ Date: string; Close: number; Volume?: number | null }> }>(API_ENDPOINTS.deepDiveHistoricalPrice(ticker));
    return response.data?.historical_price ?? null;
  } catch (error) {
    console.error(`Error fetching historical price for ${ticker}:`, error);
    return null;
  }
}

export async function fetchFundamentals(ticker: string): Promise<{
  market_cap: number | null;
  volume: number | null;
  avg_volume: number | null;
  float_shares: number | null;
  short_percent_float: number | null;
} | null> {
  try {
    const response = await apiClient.get<{ fundamentals: {
      market_cap: number | null;
      volume: number | null;
      avg_volume: number | null;
      float_shares: number | null;
      short_percent_float: number | null;
    } }>(API_ENDPOINTS.deepDiveFundamentals(ticker));
    return response.data.fundamentals;
  } catch (error) {
    console.error(`Error fetching fundamentals for ${ticker}:`, error);
    return null;
  }
}

export async function fetchStockPrices(tickers: string[]): Promise<StockPricesResponse | null> {
  try {
    const response = await apiClient.post<StockPricesResponse>(API_ENDPOINTS.stockPrices, {
      tickers,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching stock prices:', error);
    return null;
  }
}

